import { useComponentsMessages } from '@color/continuum';
import { handleIntlError } from '@color/i18n';
import { usePreferredLocale } from '@color/lib';
import { IntlProvider } from 'react-intl';

import { useDeprecatedMomentLocale } from 'ui/common/hooks/locale/useMomentLocale';
import { useHomeMessagesQuery } from 'ui/translations/useHomeMessagesQuery';

interface Props {
  children?: React.ReactNode;
}

/**
 * Provide translated messages.
 *
 * IMPORTANT: This component ensures that the app's content is not blanked out when changing
 * locale. It relies on `useRemoteMessagesQuery` keeping previously loading messages while retrieving
 * a new locale's messages.
 * See https://getcolor.atlassian.net/browse/UXTASK-554 and
 * https://getcolor.atlassian.net/browse/DX-1448
 */
export const AppIntlProvider: React.FC<Props> = (props) => {
  const { locale } = usePreferredLocale();
  useDeprecatedMomentLocale();
  const componentsMessages = useComponentsMessages({ locale });

  const { data: homeMessages } = useHomeMessagesQuery(locale);

  const allMessages = { ...componentsMessages, ...homeMessages };

  return (
    <IntlProvider locale={locale} messages={allMessages} onError={handleIntlError}>
      {props.children}
    </IntlProvider>
  );
};
